import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import Layout from '@/components/layout/Layout';
import Desktop from '@/components/tos/desktop/Desktop';
import Mobile from '@/components/tos/mobile/Mobile';
import { tosPage, content } from '@/constants/tos';

export default function Index() {
  const router = useRouter();
  const {
    query: { id },
  } = router;

  const page = Array.isArray(id) ? id[0] : id;
  const isValid = Object.values(tosPage).some(validPage => validPage === page);

  useEffect(() => {
    if (!isValid) {
      router.push('/tos/bee', undefined, { shallow: true });
    }
  }, [page, isValid]);

  const defaultPage = isValid ? (page as tosPage) : tosPage.mappingNetwork;
  const data = content[defaultPage];
  const sections = data.sections;

  return (
    <Layout gradientBg containerClassName="px-4 md:px-0">
      <Mobile data={data} sections={sections} page={defaultPage} />
      <Desktop data={data} sections={sections} page={defaultPage} />
    </Layout>
  );
}
